import { render, staticRenderFns } from "./ManageAccess.vue?vue&type=template&id=66fe0222&scoped=true&"
import script from "./ManageAccess.vue?vue&type=script&lang=js&"
export * from "./ManageAccess.vue?vue&type=script&lang=js&"
import style0 from "./ManageAccess.vue?vue&type=style&index=0&id=66fe0222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fe0222",
  null
  
)

export default component.exports